import * as React from "react"
const SvgMenu = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 18.857a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713q0-.424.288-.712A.97.97 0 0 1 4 16.857h16q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287zm0-5a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713q0-.424.288-.712A.97.97 0 0 1 4 11.857h16q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287zm0-5a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 7.857q0-.424.288-.712A.97.97 0 0 1 4 6.857h16q.424 0 .712.288.288.287.288.712c0 .425-.096.521-.288.713a.97.97 0 0 1-.712.287z" />
  </svg>
)
export default SvgMenu
